import React from 'react'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import {delItem} from '../redux/actions/index'
import { NavLink } from 'react-router-dom'


const Cart = () => {
    const state = useSelector((state)=> state.addItem)
    const dispatch = useDispatch()

    const handleClose = (item) => {
        dispatch(delItem(item))
    }

    const cartItems = (cartItem) => {
        return(
            <div className="px-4 my-5 bg-light rounded-3" key={cartItem.id}>
                <div className="container py-4">
                    <button onClick={()=>handleClose(cartItem)} className="btn-close float-end" aria-label="Close"></button>
                    <div className="row justify-content-center">
                        <div className="col-md-4">
                            <img src={cartItem.img} alt={cartItem.title} height="200px" width="180px" />
                        </div>
                        <div className="col-md-4">
                            <h3>{cartItem.title}</h3>
                            <p className="lead fw-bold" style={{color: '#3d40dd'}}>${cartItem.price}</p>
                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const emptyCart = () => {
        return (
            <div className="px-4 my-5 bg-light rounded-3 py-5">
                <div className="container py-4">
                    <div className="row">
                        <h3 style={{textAlign:"center"}}>Your Cart is Empty.</h3>
                        <h6 style={{textAlign:"center"}}>Add Some Products!</h6>
                        <hr className="my-4" />
                    </div>
                    <div align="center" className="container">
                    <NavLink to="/productsNike" className="btn btn-outline-primary mb-5 w-25 mx-auto">Featured products</NavLink>
                    </div>

                    <div align="center" className="container">
                    <NavLink to="/products" align="center" className="btn btn-outline-primary mb-5 w-25 mx-auto">All Products</NavLink>
                    </div>

                    </div>
                </div>
        );
    }

    const button = () => {
        return(
            <div className="container">
                <div className="row">
                    <NavLink to="/checkout" className="btn btn-outline-primary mb-5 w-25 mx-auto">Proceed To checkout</NavLink>
                </div>
            </div>
        );
    }
    const button2 = () => {
        return(
            <div align="center" className="container">
                    <a href="/cart"><button className="btn btn-outline-danger mb-5 w-25  mx-auto">Empty Cart</button></a> 
            </div>
        );
    }

    return (
        <>
            {state.length === 0 && emptyCart()}
            {state.length !== 0 && state.map(cartItems)}
            {state.length !== 0 && button()}
            {state.length !== 0 && button2()}
        </>
    )
}

export default Cart
